var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M16 22a1 1 0 0 1-1-1v-5.75a1 1 0 0 1 2 0V21a1 1 0 0 1-1 1z",
    opacity: 1,
    "data-original": "#7fbde7",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M20.801 27H11.2a4.023 4.023 0 0 1-3.43-1.941l-4.2-7a3.992 3.992 0 0 1 0-4.118l4.2-7A4.023 4.023 0 0 1 11.199 5H20.8a4.023 4.023 0 0 1 3.43 1.941l4.2 7a3.992 3.992 0 0 1 0 4.118l-4.2 7A4.023 4.023 0 0 1 20.801 27zM11.2 7a2.01 2.01 0 0 0-1.716.97l-4.2 7a1.997 1.997 0 0 0 0 2.06l4.2 7A2.01 2.01 0 0 0 11.2 25H20.8a2.01 2.01 0 0 0 1.716-.97l4.2-7a1.997 1.997 0 0 0 0-2.06l-4.2-7A2.01 2.01 0 0 0 20.8 7z",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12.25,
    r: 1.25,
    fill: "#0e9941",
    opacity: 1,
    "data-original": "#7fbde7",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c890178ab91e8bfd3b78ee41cc79f535.svg";
export { ForwardRef as ReactComponent };